<svg
  id="ecyoTNiPuEx1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <defs>
    <linearGradient
      id="ecyoTNiPuEx14-fill"
      x1="106.2272"
      y1="303.6639"
      x2="183.7572"
      y2="303.6639"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="ecyoTNiPuEx14-fill-0" offset="0%" stop-color="#fad1c7" />
      <stop id="ecyoTNiPuEx14-fill-1" offset="100%" stop-color="#edbdb9" />
    </linearGradient>
  </defs>
  <g id="ecyoTNiPuEx2_ts" transform="translate(230.400002,145.399994) scale(0,0)">
    <g id="ecyoTNiPuEx2" transform="translate(-230.400002,-145.399994)" opacity="0">
      <circle r="87.3" transform="translate(230.4 145.4)" fill="#fabe6e" />
      <circle r="76.7" transform="translate(230.4 145.4)" opacity="0.52" fill="#f7a623" />
    </g>
  </g>
  <g id="ecyoTNiPuEx5_ts" transform="translate(230.399986,145.399994) scale(0,0)">
    <g id="ecyoTNiPuEx5" transform="translate(-230.399986,-145.399994)" opacity="0">
      <circle r="76.7" transform="translate(230.4 145.4)" opacity="0.52" fill="#f7a623" />
    </g>
  </g>
  <g id="ecyoTNiPuEx7_to" transform="translate(145.000002,560.087015)">
    <g id="ecyoTNiPuEx7_tr" transform="rotate(67.60934)">
      <g transform="translate(-144.999988,-420.639589)">
        <g>
          <g>
            <g>
              <image
                width="374"
                height="1036"
                xlink:href="7A43A4C74132A5C4.png"
                preserveAspectRatio="xMidYMid meet"
                transform="matrix(.24 0 0 0.24 104.16 211.68)"
                opacity="0.05"
              />
              <g>
                <g>
                  <path
                    d="M183.1,275.9l.6,99.6c0,0-7.3,13.4-34,14.2s-43.5-14.2-43.5-14.2v-129.2c0,0,4.3-28.9,42.8-28.6c29.1.2,34.2,28,34.1,58.2Z"
                    fill="url(#ecyoTNiPuEx14-fill)"
                  />
                  <path
                    d="M183.8,340.2l-2.9,114.1c0,0-7.3-.8-34,0s-40.7-19.9-40.7-19.9v-94.2c0,0,16.8,15,43.5,14.2c26.8-.9,34.1-14.2,34.1-14.2Z"
                    fill="#00a19a"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="ecyoTNiPuEx16_tr" transform="translate(144.619567,246.944) rotate(24.532645)">
          <g transform="translate(-144.619567,-246.944)">
            <g>
              <g>
                <path
                  d="M288.7,156.7l-86.1,86.1-15.1,15.1c-4.4,4.4-11.5,4.4-15.9,0l-30.1-30.1L124.7,211c.9-.8,40.2-33.5,80-35.4c59.6-2.8,73.2-45.5,73.2-45.5l10.8,10.8c4.4,4.3,4.4,11.4,0,15.8Z"
                  fill="#1a1731"
                />
              </g>
              <g>
                <g>
                  <path
                    d="M230.9,83.1c-4.4-4.4-11.5-4.4-15.9,0L113.9,184.3c-4.4,4.4-4.4,11.5,0,15.9l10.7,10.7.1.1c0,0,0,0,0,0c.9-.8,40.2-33.5,80-35.4c59.6-2.8,73.2-45.5,73.2-45.5l-47-47Zm14.6,52.5L231.1,150c-2.4,2.4-6.2,2.4-8.6,0l-7-7c-2.4-2.4-2.4-6.2,0-8.6L229.9,120c2.4-2.4,6.2-2.4,8.6,0l7,7c2.4,2.4,2.4,6.3,0,8.6Z"
                    fill="#24224e"
                  />
                </g>
              </g>
              <path
                d="M245.5,135.6L231.1,150c-2.4,2.4-6.2,2.4-8.6,0l-7-7c-2.4-2.4-2.4-6.2,0-8.6L229.9,120c2.4-2.4,6.2-2.4,8.6,0l7,7c2.4,2.4,2.4,6.3,0,8.6Z"
                fill="#f39200"
              />
            </g>
            <g>
              <g>
                <path
                  d="M202.6,242.9v14.1c0,5.7-1.3,9.8-3.1,13.3-6,11.6-28.1,26.1-53.3,26.1-28.7,0-40-26.6-40-26.6v-23.5c0-9.7-2.1-23.5,4.4-30.7l8.9-9.9l5.2,5.3c0,0,0,0,0,0l16.9,16.9l28.5-30c2.8-2.9,6.8-4.3,10.7-3.3c2.9.7,5.7,2.6,6.7,7.3c1.7,7.9-1,14.6-2.6,17.7-.5,1-1.2,2-2.1,2.8l-11.5,11.5c-2.3,2.3-3.5,5.4-3.4,8.6.1,3.4.5,7.6.1,11.9l2.7,2.7.9.9c4.4,4.4,11.5,4.4,15.9,0l15.1-15.1Z"
                  fill="#fad1c7"
                />
              </g>
              <line x1="141.6" y1="227.8" x2="124.6" y2="245.7" fill="none" stroke="#d3978c" stroke-miterlimit="10" />
              <path
                d="M170.7,257.1c-.9,5.5-3.1,9.7-6.5,12.6-1.8,1.6-3.7,2.9-5.6,4l-1.5-2.6c1.7-1,3.5-2.2,5.2-3.7c3.3-2.8,5.2-7,5.8-12.9l2.6,2.6Z"
                fill="#d3978c"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
